<template>
    <div class="wrapper">
        <div class="singleDealMenu">
            <singleOrderMenu
                ref="singleDealMenuComp"
                @confirmReceived="confirmReceived"
                @finalizeOrder='finalizeOrder'
                @markShipped="markShipped"
                @refuseDeals="refuseDeals"
                @acceptDeals="acceptDeals"
                :dealData="dealData"
                :subStatus="subStatus"
                :role="role"
                :statusChange="statusChange"
                :shopData="shopData"
            />
        </div>
        <successAnimation 
            v-if="successAnimationActive"
            :height="'100%'"
            :width="'100%'"
            :checkmarkHeight="'250px'"
            :checkmarkWidth="'250px'"
            :top="'0'"
        />
        <div class="mainBody">
            <div class="flexBody">
                <div class="orderHeader">
                    <invoice 
                        ref="invoice"
                        :userLegalEntity='userLegalEntity' 
                        :shopLegalEntity='shopLegalEntity' 
                        :orderData='orderData' 
                        :dealData='dealData' 
                        @downloadInvoice="downloadInvoice"
                    />
                    <img 
                        class="logo"
                        :src="require('./../assets/vegotarLogoSmall.png')" 
                        alt=""
                    >
                </div>
    
                <div class="rightSideContainer">
                    <div class="clientContainer" v-if="clientProfileData">
                        <div class="imageContainer">
                            <img 
                                class="clientImage"
                                :src="$fetchIp+'/static/images/profiles/'+clientProfileData.coverImg" 
                                alt=""
                            >
                            <p>{{clientProfileData.displayName}}</p>
                        </div>
                        <div class="buyerNote" style="animation-delay: 600ms">
                            <div class="noteBody">
                                <p style="animation-delay: 1000ms" v-if="shippingInstructions.buyersNote">{{ shippingInstructions.buyersNote }}</p>
                                <p style="animation-delay: 1000ms" class="noBuyerNote" v-else>Kliendi lisamärkused puuduvad!</p>
                            </div>
                        </div>
                    </div>
                    <div class="shippingInstructions">
                        <shippingInstructions
                            ref='shippingInstructionsComp'
                            :idOrder='idOrder'
                            :idShippingInstructions="idShippingInstructions"
                            :titleColor='"rgb(100, 100, 100)"'
                            @shippingInstructionsBack='shippingInstructionsBack'
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import singleOrderMenu from '@kristjan87/storium-workboard-library/src/components/main/orders/singleOrder/menu/menu.vue';
import invoice from '@kristjan87/storium-workboard-library/src/components/main/orders/singleOrder/invoice.vue';
import shippingInstructions from '@kristjan87/storium-workboard-library/src/components/main/orders/singleOrder/shippingInstructions.vue';

import successAnimation from '../assets/animations/success.vue'

import singleDeal from '../apiFetches(old)/singleDeal'
import userProfile from '../apiFetches(old)/userProfile'

export default {
    name: 'singleOrderView',
    components: {
        singleOrderMenu,
        successAnimation,
        shippingInstructions,
        invoice
    },
    props: {
        idShop: null,
        shopData: null,
    },
    // watch: {
    //     shippingProfile: {
    //         handler(newVal) {
    //             if (newVal) {
    //                 this.render = true
    //                 this.setShippingMethods()
    //                 // this.setShopData()
    //             }
    //         },
    //         immediate: true, // Executes the watcher immediately on component creation
    //         deep: true // Watches the nested properties if needed
    //     }
    // },
    data() {
        return {
            successAnimationActive: false,
            statusChange: false,

            idDeal: Number(this.$route.params.idDeal),
            idOrder: Number(this.$route.params.idOrder),
            idShippingInstructions: null,
            idUser: '',
            role: '',

            clientProfileData: null,
            dealData: '',
            orderData: '',
            statusData: '',

            status: '',
            subStatus: '',

            amount: '',
            shippingInstructions: '',
            userLegalEntity: '',
            shopLegalEntity: '',
        };
    },
    computed: {
      
    },
    methods: {
        controlFunction() {

        },
        getShippingInstructions() {
            this.$refs.invoice.amount = this.dealData.amount + this.extraAmount
            this.amount = this.dealData.amount + this.extraAmount
            setTimeout(() => {
                this.isLoading = false
            }, 100)
            setTimeout(() => {
                this.$refs.shippingInstructionsComp.shippingInstructions()
            }, 1)
        },

        shippingInstructionsBack(shippingInstructionsData, pickupMethod, packageBoxMethod, arrangementMethod, sellerMethod) {
            this.shippingInstructions = shippingInstructionsData
            this.$refs.invoice.shippingInstructions = shippingInstructionsData
            this.$refs.invoice.pickupMethod = pickupMethod
            this.$refs.invoice.packageBoxMethod = packageBoxMethod
            this.$refs.invoice.arrangementMethod = arrangementMethod
            this.$refs.invoice.sellerDeliveryMethod = sellerMethod
        },

        downloadInvoice(idInvoice, reference) {
            fetch(this.$fetchIp+'/v2/'+'deal/'+this.idDeal+'/invoice/'+idInvoice+'/pdf', {
                method: 'GET',
                credentials: 'include',
            })
            .then((res) => res.blob())
            .then((res) => {
                const url = window.URL.createObjectURL(new Blob([res]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${reference}.pdf`);
                document.body.appendChild(link);
                link.click();
            })
        },

        fetchDealData() {
            singleDeal(this.idDeal)
            .then((res) => {
                this.dealData = res.data.deal
                this.idShippingInstructions = res.data.deal.shipping.idShippingInstructions
                
                // var buyer
                // for(const element of res.data.deal.legalEntities) {
                //     if(element.side == 'buyer') {
                //         buyer = element
                //     } 
                // }
                

                const { dealData } = this;

                if (dealData.isCancelled) {
                    this.status = 'isCancelled';
                } else if (dealData.isRejected) {
                    this.status = 'rejected';
                } else if (dealData.isFinalized || dealData.isAwaitingSignature) {
                    this.status = 'isFinalized';
                } else if (dealData.isDisputed) {
                    this.status = 'isDisputed';
                } else if (dealData.isDelivered) {
                    this.status = 'isDelivered';
                } else if (dealData.isShipped) {
                    this.status = 'isShipped';
                } else if (dealData.isAccepted) {
                    this.status = 'isNotShipped';
                } else if (dealData.isPaid && !dealData.isAccepted) {
                    this.status = 'isNotAccepted';
                }
                if (this.dealData.attr.extraPaymentReqs.length != 0) {
                    this.extraPayments = []
                    this.extraPaymentsAmounts = []
                    for (const element of this.dealData.attr.extraPaymentReqs) {
                        if (element.isPaid == true) {
                            this.extraPayments.push(element)
                            this.extraPaymentsAmounts.push(Number(element.amount))
                            this.subStatus = ''
                            this.additionalAskedAmount = ''
                            this.additionalPaymentReason = ''
                            this.idExtraPaymentReq = ''
                        } else {
                            this.subStatus = 'additionalPayment'
                            this.additionalAskedAmount = element.amount
                            this.additionalPaymentReason = element.reference
                            this.idExtraPaymentReq = element.idExtraPaymentReq
                        }
                    }
                    this.$refs.invoice.extraPayments = this.extraPayments
                    this.extraAmount = this.extraPaymentsAmounts.reduce((a, b) => {
                        return a + b;
                    }, 0)
                }
                for(const singleEntity of this.dealData.legalEntities) {
                    if(singleEntity.affiliatedResource == 'user') {
                        this.userLegalEntity = singleEntity
                    } else {
                        this.shopLegalEntity = singleEntity
                    }
                }
                this.fetchUserData()
                this.getShippingInstructions()
            })
        },

        fetchOrder() {
            fetch(this.$fetchIp+'/v2/deal/listings/'+this.idDeal, {
                method: 'GET',
                headers: {
                    'Content-type':'application/json'
                },
                credentials: 'include',
            })
            .then((res) => res.json())
            .then((res) => {
                if(res.status == 'success') {
                    this.orderData = res.data.listings
                    this.fetchDealData()
                } else {
                    // error handler
                    this.fetchDealData()
                }
            })
        },

        fetchUserData() {
            userProfile(this.dealData.idAuthor)
            .then((res) => {
                if(res.status == 'success') {
                    this.clientProfileData = res.data.profile
                    this.role = null
                    if(this.clientProfileData.idProfile == this.idUser) {
                        this.role = 'buyer'
                    } else {
                        this.role = 'seller'
                    }
                } else {
                    this.clientProfileData = null
                }
            })
        },

        confirmReceived() {
            fetch(this.$fetchIp+'/v2/deal/mark/delivered/'+this.idDeal, {
                    method: 'PATCH',
                    headers: {
                        'Content-type':'application/json'
                    },
                    credentials: 'include',
                })
            .then((res) => res.json())
            .then((res) => {
                if(res.status === 'success') {
                    this.fetchDealData()
                    this.statusChange = !this.statusChange
                }
            })
        },

        finalizeOrder() {
            fetch(this.$fetchIp+'/v2/deal/finalize/'+this.idDeal, {
                method: 'PATCH',
                headers: {
                    'Content-type':'application/json'
                },
                credentials: 'include',
            })
            .then((res) => res.json())
            .then((res) => {
                if(res.status === 'success') {
                    this.fetchDealData()
                    this.statusChange = !this.statusChange
                }
            })
        },

        markShipped() {
            fetch(this.$fetchIp+ '/v2/deal/mark/shipped/' + this.idDeal, {
                method: 'PATCH',
                headers: {
                    'Content-type':'application/json'
                },
                credentials: 'include',
            })
            .then((res) => res.json())
            .then((res) => {
                if(res.status === 'success') {
                    this.fetchDealData()
                    this.statusChange = !this.statusChange
                }
            })
        },

        acceptDeals() {
            const acceptOrder = async () => {
                try {
                    const response = await fetch(this.$fetchIp + '/v2/deal/accept/' + this.idDeal, {
                        method: 'PATCH',
                        headers: {
                            'Content-type': 'application/json'
                        },
                        credentials: 'include',
                    });

                    const res = await response.json();

                    if (res.status === 'success') {
                        this.fetchDealData();
                        this.statusChange = !this.statusChange;
                    }
                } catch (error) {
                    console.error('Error accepting order:', error);
                }
            };

            this.$confirm.require({
                message: `Oled kindel, et soovid tellimuse vastu võtta?`,
                header: 'Kinnitus',
                icon: 'pi pi-exclamation-triangle',
                rejectProps: {
                    label: 'Tühista',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Kinnita'
                },
                accept: acceptOrder
            });
        },

        refuseDeals() {
            const refuseOrders = async () => {
                try {
                    const response = await fetch(this.$fetchIp + '/v2/deal/reject/' + this.idDeal, {
                        method: 'PATCH',
                        headers: {
                            'Content-type': 'application/json'
                        },
                        credentials: 'include',
                    });

                    const res = await response.json();

                    if (res.status === 'success') {
                        this.fetchDealData();
                        this.statusChange = !this.statusChange;
                    }
                } catch (error) {
                    console.error('Error rejecting order:', error);
                }
            };

            this.$confirm.require({
                message: `Oled kindel, et soovid tellimuse TAGASI LÜKATA?`,
                header: 'Kinnitus',
                icon: 'pi pi-exclamation-triangle',
                rejectProps: {
                    label: 'Tühista',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Kinnita'
                },
                accept: refuseOrders
            });
        },


        roundtrip: async function() {
            fetch(`${ this.$fetchIp }/v2/roundtrip`, {
                method: 'GET',
                headers: {
                    'Content-type':'application/json'
                },
                credentials: 'include',
            })
            .then(res => res.json())
            .then(res => {
                this.idUser = res.idUser
                this.fetchOrder()
            })
        },
    },
    created() {
      // Lifecycle hook - called after the instance is created
        this.roundtrip()
    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>
  
<style scoped>
.wrapper {
    background: rgb(238, 242, 245);
    height: 100%;
    min-height: 100vh;
    margin: 0;
}
.singleDealMenu {
    display: fixed;
}
.mainBody {
    position: relative;
    width: 1420px;
    padding-top: 150px;
    margin: 0 auto;
}
.flexBody {
    display: flex;
    justify-content: space-between;
}
.orderHeader {
    position: relative;
    width: 890px;
    padding-top: 80px;
    padding-bottom: 0px;
    padding-right: 50px;
    padding-left: 50px;
    margin-bottom: 0px;
    border-radius: 15px;
    overflow: hidden;
    border: 1px solid rgb(230,230,230);
    background: rgb(255, 255, 255);
}
.logo {
    position: absolute;
    left: 50px;
    bottom: 40px;
    opacity: .1;
}
.singleDealMenu.vue-fixed-header {
    width: 100%;
    position: absolute;
    top: 65px;
    left: 0;
    z-index: 1002;
}
.singleDealMenu.vue-fixed-header--isFixed {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1002;
}
.statusComponents {
    margin-top: -0px;
    margin-bottom: -0px;
    text-align: center;
}
.clientContainer {
    position: relative;
    margin-left: auto;
    border-radius: 15px;
    width: 500px;
    height: 150px;
    margin-bottom: 10px;
    /* background: rgb(255, 255, 255); */
    border-top: 1px solid rgba(230, 230, 230, 0); 
}
.imageContainer {
    position: absolute;
    left: 0px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: fit-content;
    height: fit-content;
    text-align: center;
}
.imageContainer p {
    margin: 0;
    min-width: 100px;
    max-width: 140px;
    text-align: center;
    font-size: 1.1rem;
    color: rgb(75,75,75);
    font-weight: bold;
}
.clientImage {
    width: 80px;
    height: 80px;
    border-radius: 100%;
    -webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
    background: white;
}
.buyerNote {
    position: relative;
    margin-left: auto;
    margin-right: 0px;
    margin-top: 12px;
    border:1px solid steelblue;
    background: white;
    text-align: center;
    width: 70%;
    height: 0px;
    border-radius: 10px;
    padding: 0px;
    -webkit-animation: statsAnimation .5s ease-in-out forwards;
            animation: statsAnimation .5s ease-in-out forwards;
    /* -webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2); */
}
.noteBody {
    height: 100%;
    overflow: auto;
}
.buyerNoteAnimation {
    width: 0;
    -webkit-animation: statsAnimation .3s ease-in-out forwards;
            animation: statsAnimation .3s ease-in-out forwards;
}
.buyerNote:after {
    content: '';
    position: absolute;
    display: block;
    width: 0;
    z-index: 1;
    border-style: solid;
    border-color: transparent steelblue;
    border-width: 25px 25px 25px 0;
    top: 50%;
    left: 0px;
    opacity: 0;
    margin-top: -25px;
    -webkit-animation: arrowAnimation .3s ease-in-out forwards;
            animation: arrowAnimation .3s ease-in-out forwards;
            animation-delay: 1100ms;
        
}
.buyerNote p {
    height: fit-content;
    width: 100%;
    font-size: 16px;
    padding-right: 10px;
    padding-left: 10px;
    color: rgb(66, 66, 66);
    opacity: 0;
    font-family: 'DM sans', sans-serif;
    -webkit-animation: textAnimation .3s ease-in-out forwards;
            animation: textAnimation .3s ease-in-out forwards;
}
.noBuyerNote {
    font-weight: bold;
    margin-top: 43px;
}
.shippingInstructions {
    margin-left: auto;
    border-radius: 15px;
    width: 500px;
    padding-bottom: 0px;
    background: rgb(255, 255, 255);
    border: 1px solid rgb(230,230,230);
    overflow: hidden;
    padding-left: 20px;
    padding-right: 20px
}

@keyframes statsAnimation {
    0% {
        height: 0px;
    }
    100% {
        height: 115px;
    }
}
@keyframes textAnimation {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
@keyframes arrowAnimation {
    0% {
        opacity: 0;
        left: 0px;
    }
    100% {
        opacity: 1;
        left: -25px;
    }
}

@media (max-width: 1450px) {
    .mainBody {
        width: 100%;
    }
}
@media (max-width: 1150px) {
    .flexBody {
        flex-wrap: wrap;
    }
    .orderHeader {
        margin-right: 0;
        width: 100%;
        border-radius: 0;
        padding-top: 120px;
        margin-top: -50px;
    }
    .rightSideContainer {
        width: 100%;
    }
    .shippingInstructions {
        width: 100%;
        border-radius: 0;
        padding-right: 50px;
        padding-left: 50px;
    }
    .clientContainer {
        margin-left: auto;
        margin-right: auto;
    }
}
@media (max-width: 750px) {
    .orderHeader {
        padding-left: 15px;
        padding-right: 15px;
    }
    .shippingInstructions {
        padding-right: 15px;
        padding-left: 15px;
    }
}
@media (max-width: 530px) {
    .clientContainer {
        width: 100%;
        padding-left: 15px;
        padding-right: 15px;
    }
    .imageContainer {
        left: 15px
    }
}
@media (max-width: 500px) {
    .wrapper {
        padding-top: 65px;
    }
}
@media (max-width: 420px) {
    .imageContainer {
        display: none;
    }
    .buyerNote {
        margin-top: 20px;
        width: calc(100% - 15px);
    }
}
</style>